import React, { FC, useEffect } from 'react';
import InnerHTML from 'dangerously-set-html-content'

const Banner = ({code}) => {
    return (
        <div style={{padding: '12px 0'}}>
            <InnerHTML
                html={code}/>
        </div>
    )
};

export default Banner;